import moment from 'moment';

// initial and default search query
const query = {
  nodeAuth: true,
  ActionDate: {
    $gte: moment().startOf('day').format()
  },
  CardStatusID: [],
  CardTypeID: []
};

const initialState = {
  searching: false,
  query,
  default_query: query 
};

export default function (state = initialState, action) {
  if(action.type === actionTypes.UPDATE_SEARCH_QUERY) {
    return {
      ...state,
      query: action.searchQuery
    }
  }

  if(action.type === actionTypes.SEARCHING) {
    return {
      ...state,
      searching: action.status
    }
  }

  return state;
}

// action types
export const actionTypes = {
  SEARCHING: "SEARCHING",
  UPDATE_SEARCH_QUERY: "UPDATE_SEARCH_QUERY"
}